import { CampaignSummaryResult, SortFieldName, SortDirection } from '../campaign';
import { AllCampaignActions, AllCampaignActionTypes } from './all-campaign.actions';

export interface AllCampaignState {
    allCampaigns: CampaignSummaryResult;
    isLoading: boolean;
    error: string;
}

const initialState: AllCampaignState = {
    allCampaigns: {
        campaigns: [],
        pagination: { index: 0, size: 10, count: 0 },
        searchInfo: { searchTerm: '' },
        sortingInfo: { fieldName: SortFieldName.empty, direction: SortDirection.none }
    },
    isLoading: false,
    error: ''
};

export function reducer(state = initialState, action: AllCampaignActions): AllCampaignState {
    switch (action.type) {
        case AllCampaignActionTypes.loadCampaignsSuccess:
            return {
                ...state,
                allCampaigns: action.payload,
                isLoading: false
            };
        case AllCampaignActionTypes.loadCampaignsFail:
            return {
                ...state,
                allCampaigns: null,
                isLoading: false,
                error: action.payload
            };
        case AllCampaignActionTypes.setIsloadingCampaigns:
            return {
                ...state,
                isLoading: true
            };
        case AllCampaignActionTypes.setPaginationInfo:
            return {
                ...state,
                allCampaigns: {
                    ...state.allCampaigns,
                    pagination: action.payload
                }
            };
        case AllCampaignActionTypes.setSortingInfo:
            return {
                ...state,
                allCampaigns: {
                    ...state.allCampaigns,
                    sortingInfo: action.payload
                }
            };
        default:
            return state;
    }
}
